import moment from 'moment-timezone';
import { SequenceConfig } from '../../enums';
import { StorageUtil } from '../../../../shared/utils/storage';

export const getNewSequenceName = (userTimeZone?: string): string => {
  const now = new Date();
  const formattedDate = userTimeZone
    ? moment(now).tz(userTimeZone).format('ddd Do MMM')
    : moment(now).format('ddd Do MMM');

  return `${SequenceConfig.NewSequenceTitle} - ${formattedDate}`;
};

const sequenceFilters = 'sequence-filters';

export const getSequenceFilterFromLocalStorage = () =>
  StorageUtil.getItem(sequenceFilters);

export const setSequenceFilterFromLocalStorage = (filters) =>
  StorageUtil.setItem(sequenceFilters, JSON.stringify(filters));

export const removeSequenceFilterFromLocalStorage = () =>
  StorageUtil.removeItem(sequenceFilters);
